var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _line, _path5, _line2, _line3, _path6, _polygon, _path7, _path8, _circle3, _circle4, _circle5, _circle6, _path9, _path10, _path11, _path12, _path13, _line4, _line5, _line6, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7aece;}.cls-2,.cls-3{fill:#515570;}.cls-2{opacity:0.2;}.cls-4{fill:#393c54;}.cls-12,.cls-15,.cls-16,.cls-17,.cls-5,.cls-6,.cls-7,.cls-9{fill:none;stroke-linecap:round;}.cls-5{stroke:#393c54;stroke-miterlimit:10;}.cls-15,.cls-16,.cls-5,.cls-7{stroke-width:2px;}.cls-6{stroke:#efb19e;stroke-width:20px;}.cls-12,.cls-15,.cls-16,.cls-17,.cls-6,.cls-7,.cls-9{stroke-linejoin:round;}.cls-12,.cls-15,.cls-16,.cls-17,.cls-7{stroke:#515570;}.cls-8{fill:#ffd8c9;}.cls-9{stroke:#ffffff;stroke-width:1.5px;}.cls-10{fill:#fbc0aa;}.cls-11{fill:#8f5653;opacity:0.7;}.cls-12{stroke-width:2.22px;}.cls-13{fill:#f85565;}.cls-14{fill:#ffffff;}.cls-15{opacity:0.1;}.cls-16{opacity:0.5;}.cls-17{stroke-width:4px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,101.76v-54a33,33,0,0,1,66,0v54C97,120.1,31,120.1,31,101.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64,124a59.77,59.77,0,0,0,39.83-15.14l-2.23-5.22c-1.71-4-6.22-6.64-11.29-6.64H37.69c-5.07,0-9.58,2.66-11.29,6.64l-2.23,5.22A59.77,59.77,0,0,0,64,124Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.43,98.73a13.43,13.43,0,0,1-26.86,0c0-5,6-3.25,13.43-3.25S77.43,93.68,77.43,98.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.43,98.73c0,7.42-7,13.43-14.43,13.43s-14.43-6-14.43-13.43"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 64,
    x2: 64,
    y1: 89.75,
    y2: 98.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54,95.26l8.68,8a2,2,0,0,0,2.7,0l8.68-8,4.4,14.53-17.26,6.88-12.34-6.84-3.16-4.39Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 76.78,
    x2: 65.17,
    y1: 96.5,
    y2: 113.88
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 51.17,
    x2: 62.78,
    y1: 96.5,
    y2: 113.88
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M64,94.37c-10,0-28.32-12.67-28.32-28.32V47.43a28.32,28.32,0,1,1,56.64,0V66.05C92.32,81.7,74,94.37,64,94.37Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "67.5 113.88 65.17 113.88 65.17 111.54 62.83 111.54 62.83 113.88 60.5 113.88 60.5 116.21 62.83 116.21 62.83 121.46 65.17 121.46 65.17 116.21 67.5 116.21 67.5 113.88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.72,102.72s-.06-37-.06-55.29c0-19.69-15.62-30.32-30.32-30.32a1.86,1.86,0,0,0-.34,0,1.86,1.86,0,0,0-.34,0c-14.7,0-30.32,10.63-30.32,30.32,0,18.25-.31,55.29-.31,55.29l4,8.53a1.56,1.56,0,0,0,3-.7V54c0-7.19,4.6-14.06,11.47-17.5L64,30.25l12.53,6.27C83.4,40,88,46.84,88,54v56.28a1.56,1.56,0,0,0,3,.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M68,69.21c0,3.4-1.79,6.16-4,6.16s-4-2.76-4-6.16,1.79-8.7,4-8.7S68,65.8,68,69.21Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 75.5,
    cy: 62.05,
    r: 8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 75.5,
    cy: 62.05,
    r: 8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 52.5,
    cy: 62.05,
    r: 8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 52.5,
    cy: 62.05,
    r: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M72,79H56V92.43a20.94,20.94,0,0,0,8,1.94,20.94,20.94,0,0,0,8-1.94Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.55,78a1,1,0,0,1,.94,1.07,8.56,8.56,0,0,1-17,0A1,1,0,0,1,56.45,78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M58,78h2a0,0,0,0,1,0,0v2a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V78A0,0,0,0,1,58,78Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M70,78H68v4a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M68,78h2a0,0,0,0,1,0,0v2a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V78A0,0,0,0,1,68,78Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 68,
    x2: 60,
    y1: 59,
    y2: 59
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 74,
    x2: 70,
    y1: 77,
    y2: 73
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 54,
    x2: 58,
    y1: 77,
    y2: 73
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M70.48,52.63a5,5,0,0,1,4.11-3.45l6.93-1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M57.52,52.63a5,5,0,0,0-4.11-3.45l-6.93-1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M40,43V73a4,4,0,0,0,4,4h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar9);
export default __webpack_public_path__ + "static/media/avatar9.cde8eab8a511959f62c585752df1c8bf.svg";
export { ForwardRef as ReactComponent };